module.exports = __webpack_public_path__ + "img/distribution-B.29c4ed34.svg";